<template>
  <div>

    <v-dialog
    v-model="error"
    width="500"
    >

      <v-card>
        <v-card-title
          class="headline red accent-3"
          primary-title
        >
          Warning Message
        </v-card-title>

        <v-card-text>
          {{errorMsg}}
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="red accent-3"
            flat
            @click="setErrorZero"
          >
            close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-toolbar flat color="white">
      <v-toolbar-title>Frequently ask questions</v-toolbar-title>
     <v-spacer></v-spacer>
       <v-text-field
        v-model="search"
        append-icon="search"
        label="Search"
        single-line
        hide-details
        align="center"
      ></v-text-field>
      <v-spacer></v-spacer>
      <v-dialog v-model="dialog" max-width="700px">
        <template v-slot:activator="{ on }">
          <v-btn color="primary" dark class="mb-2" v-on="on">Create FAQ</v-btn>
        </template>
        <v-card>
          <v-card-title class="success">
            <span class="headline">{{ formTitle }}</span>
          </v-card-title>

          <v-card-text mt-0>
            <v-layout wrap>
              <v-flex xs12 sm6 md12>
                <v-textarea v-model="editedItem.question_en" box label="Question in English"></v-textarea>
              </v-flex>
            </v-layout>
            <v-layout wrap>
              <v-flex xs12 sm6 md12>
                <!-- <v-textarea v-model="editedItem.answer_en" box label="Answer in English"></v-textarea> -->
                <ckeditor :editor="editor" v-model="editedItem.answer_en" :config="editorConfig"></ckeditor>
              </v-flex>
            </v-layout>
            <v-layout wrap>
              <v-flex xs12 sm6 md12>
                <v-textarea v-model="editedItem.question_bn" box label="Question in Bangla"></v-textarea>
              </v-flex>
            </v-layout>
            <v-layout wrap>
              <v-flex xs12 sm6 md12>
                <!-- <v-textarea v-model="editedItem.answer_bn" box label="Answeer in Bangla"></v-textarea> -->
                <ckeditor :editor="editor" v-model="editedItem.answer_bn" :config="editorConfig"></ckeditor>
              </v-flex>
            </v-layout>
            <v-layout wrap class="mt-2">
                <v-flex xs12 sm6 md12>
                  <v-select 
                  v-model="editedItem.faq_type" 
                  :items="faq_types" 
                  item-text="value" 
                  item-value="value" 
                  box label="Select Faq Type"
                  ></v-select>
                </v-flex>
              </v-layout>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" flat @click="close">Cancel</v-btn>
            <v-btn color="blue darken-1" flat @click="save">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-toolbar>
    <v-data-table
      :headers="headers"
      :items="indexData.faqs"
      :search="search"
      class="elevation-1"
    >
      <template v-slot:items="props">
        <td class="text-xs-center">{{ props.item.id }}</td>
        <td class="text-xs-center">{{ props.item.created_by }}</td>
        <td class="text-xs-center">{{ props.item.faq_type }}</td>
        <td class="text-xs-center">{{ props.item.question_en }}</td>
        <td class="text-xs-center">{{ props.item.answer_en }}</td>
        <td class="text-xs-center">{{ props.item.question_bn }}</td>
        <td class="text-xs-center">{{ props.item.answer_bn }}</td>
        <td class="text-xs-center">{{ props.item.active }}</td>
        <td class="justify-center layout px-0">
          <v-icon
            small
            class="mr-2"
            @click="editItem(props.item)"
          >
            edit
          </v-icon>
          <v-icon
            small
            @click="deleteItem(props.item)"
          >
            delete
          </v-icon>
        </td>
      </template>
      <template v-slot:no-data>
        <v-btn color="primary" @click="initialize">Reset</v-btn>
      </template>
    </v-data-table>
  </div>
</template>
<script>
import {mapGetters} from 'vuex'
// import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import ClassicEditor from 'ckeditor5-build-classic-base64-upload';

 export default {
    data: () => ({
      dialog: false,
      search: '',
      apiUrl: 'faqs',
      headers: [
        {
          text: 'ID',
          align: 'center',
          value: 'id'
        },
        {
          text: 'Created By',
          align: 'center',
          sortable: false,
          value: 'created_by'
        },
        {
          text: 'Faq Type',
          align: 'center',
          sortable: false,
          value: 'faq_type'
        },
        {
          text: 'Question(English)',
          align: 'center',
          sortable: false,
          value: 'question_en'
        },
        { text: 'Answer(English)', align:'center',value: 'answer_en' },
        { text: 'Question(Bangla)', align:'center',value: 'question_bn' },
        { text: 'Answer(Bangla)', align:'center',value: 'answer_bn' },
        { text: 'active', align:'center',value: 'active' },
        { text: 'Actions', align:'center',value: 'actions' },
      ],
      faq_types:[
        {value:"App"},
        {value:"Admin"},
      ],
      editedIndex: -1,
      editedItem: {
        id:null,
        question_en: null,
        answer_en: null,
        question_bn: null,
        answer_bn:null,
        faq_type:null,
      },
      defaultItem: {
        id:null,
        question_en: null,
        answer_en: '',
        question_bn: null,
        answer_bn: '',
        faq_type:null,
      },
      editor: ClassicEditor,
      editorData: '<p>Content of the editor.</p>',
      editorConfig: {
          // The configuration of the editor.
      }
    }),

    computed: {
      ...mapGetters(['isLoggedIn', 'indexData', 'error', 'statusCode', 'errorMsg', 'investorAgreement', 'investeeAgreement', 'userImage', 'docImage']),
      formTitle () {
        return this.editedIndex === -1 ? 'Create FAQ' : 'Edit FAQ'
      }
    },

    watch: {
      dialog (val) {
        val || this.close()
      }
    },

    created () {
      this.initialize()
    },

    methods: {
      initialize () {
        this.$store.dispatch('setIndexData', [this.apiUrl])
      },

      setErrorZero () {
        this.$store.dispatch('setErrorZero')
      },

      editItem (item) {
        this.editedIndex = this.indexData.faqs.indexOf(item)
        this.editedItem.id = item.id
        this.editedItem.question_en = item.question_en
        this.editedItem.answer_en = item.answer_en
        this.editedItem.question_bn = item.question_bn
        this.editedItem.answer_bn = item.answer_bn
        this.dialog = true
      },

      deleteItem (item) {
        const index = this.indexData.faqs.indexOf(item)
        confirm('Are you sure you want to delete this item?') && this.indexData.faqs.splice(index, 1)
        this.$store.dispatch('delete', [this.apiUrl, item.id])
        this.initialize()
      },

      close () {
        this.dialog = false
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        }, 300)
      },

      save () {
        if (this.editedIndex > -1) {
          this.$store.dispatch('store', [this.apiUrl, this.editedItem])
          this.initialize()
        } else {
          this.$store.dispatch('store', [this.apiUrl, this.editedItem])
          this.initialize()
        }
        this.close()
      }
    }
  }
</script>